import React, { useRef } from 'react'
import PrimaryTitle from '../../../../components/PrimaryTitle'
import { inject, observer } from 'mobx-react'
import { Input, DateInput } from '../../../../components/formComponents'
import { Form, Button } from 'react-bootstrap'
import DocumentStore from '../../../../store/documentForm.store'
import PropTypes from 'prop-types'
import t from '../../../../service/translate.service'
import ContractSelector from '../../../../components/contractSelector'
import { buildValidators } from '../../../../service/validate'
import { Alert } from 'antd'
import { useNavigate } from 'react-router-dom'

const OtherContractPartner = (props) => {
  const inputRefs = useRef({})
  const { model, setVal, otherContractValidators, otherContractValidatorInputs, errorsList, errorListVoice, submitted } = DocumentStore
  const { file } = props
  const validatorBlur = buildValidators(otherContractValidatorInputs, true)
  const navigate = useNavigate()

  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'otherContractBirthDate' || key === 'date') {
        if (validatorBlur[key] && validatorBlur[key](item?.props?.selected, item?.props['aria-label'])) {
          let err = validatorBlur[key](item?.props?.selected, item?.props['aria-label'])
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.setFocus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      } else {
        if (validatorBlur[key] && validatorBlur[key](item.value, item.ariaLabel)) {

          let err = validatorBlur[key](item.value, item.ariaLabel)
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      }       
    }
    return errors
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    DocumentStore.submit(file.fileName, props.contractStore.selectedContract.contractNumber, generateErrorList)
  }
  const getAttrs = field => {
    return {
      value: model[field],
      onChange: e => setVal(field, e.target.value),
      validate: otherContractValidators[field],
      blurValidate: validatorBlur[field]
    }
  }

  const AlertContent = () => {
    if (errorsList?.length > 0) {
      if (props?.documentFormHolderRef) {
        props.documentFormHolderRef?.current?.scrollTo(0,0)
      }
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }

  return (
    <div className="form-holder">
      <PrimaryTitle title={t.OTHER_CONTRACT_PARTNER} />
      {submitted && (
        <AlertContent />
      )}
      <Form>
        <ContractSelector required={true} label padding page='documents' aria-label={t.SELECT_CONTRACT} />
        <h3 className='inputs-text'>{t.OTHER_CONTRACT_PARTNER_HEAD_ONE}</h3>
        <Input ref={(el) => (inputRefs.current['fullName'] = el)} autoComplete="name" name='fullName' {...getAttrs('fullName')} label={t.DIGITAL_CONTRACT_FORM_FULL_NAME + '*'} aria-label={t.FULL_NAME} />
        <h3 className='inputs-text'>{t.OTHER_CONTRACT_PARTNER_HEAD_TWO}</h3>
        <Input ref={(el) => (inputRefs.current['otherContractFirstName'] = el)} autoComplete="given-name" name='firstName' {...getAttrs('otherContractFirstName')} label={t.DIGITAL_CONTRACT_FORM_FIRST_NAME + '*'} aria-label={t.FIRST_NAME} />
        <Input ref={(el) => (inputRefs.current['otherContractLastName'] = el)} autoComplete="family-name" name='lastName' {...getAttrs('otherContractLastName')} label={t.DIGITAL_CONTRACT_FORM_LAST_NAME + '*'} aria-label={t.LAST_NAME} />
        <Input ref={(el) => (inputRefs.current['otherContractRelationship'] = el)} name='otherContractRelationship' {...getAttrs('otherContractRelationship')} label={t.DIGITAL_CONTRACT_FORM_KIND_OF_RELATIONSHIP + '*'} aria-label={t.KIND_OF_RELATIONSHIP} />
        <p className='inputs-text'>{t.DIGITAL_CONTRACT_DESCRIPTION_RELATIONSHIP}</p>
        <DateInput blurValidate={validatorBlur['otherContractBirthDate']} ref={(el) => (inputRefs.current['otherContractBirthDate'] = el)} name='otherContractBirthDate' value={model['otherContractBirthDate']} onChange={(date) => setVal('otherContractBirthDate', date)} validate={otherContractValidators['otherContractBirthDate']} label={t.DIGITAL_CONTRACT_FORM_DATE_OF_BIRTH + '*'} aria-label={t.DATE_OF_BIRTH} />
        <Input ref={(el) => (inputRefs.current['otherContractAddress'] = el)} name='otherContractAddress' {...getAttrs('otherContractAddress')} label={t.DIGITAL_CONTRACT_FORM_PREVIOUS_ADDRESS + '*'} aria-label={t.PREVIOUS_ADDRESS} />
        <Input ref={(el) => (inputRefs.current['otherContractPostCode'] = el)} autoComplete="postal-code" name='otherContractPostCode' {...getAttrs('otherContractPostCode')} label={t.DIGITAL_CONTRACT_FORM_POSTCODE + '*'} aria-label={t.POSTCODE} />
        <Input ref={(el) => (inputRefs.current['otherContractTown'] = el)} name='otherContractTown' {...getAttrs('otherContractTown')} label={t.DIGITAL_CONTRACT_FORM_TOWN + '*'} aria-label={t.TOWN} />
        <Input ref={(el) => (inputRefs.current['otherContractPhone'] = el)} autoComplete="tel" name='otherContractPhone' {...getAttrs('otherContractPhone')} label={t.DIGITAL_CONTRACT_FORM_PHONE_NUMBER + '*'} aria-label={t.PHONE_NUMBER} />
        <Input ref={(el) => (inputRefs.current['place'] = el)} autoComplete="address-level2" name='place' {...getAttrs('place')} label={t.DIGITAL_CONTRACT_FORM_PLACE + '*'} aria-label={t.PLACE} />
        <DateInput blurValidate={validatorBlur['date']} ref={(el) => (inputRefs.current['date'] = el)} name='date' value={model['date']} onChange={(date) => setVal('date', date)} validate={otherContractValidators['date']} label={t.DIGITAL_CONTRACT_FORM_DATE + '*'} aria-label={t.DATE} />
        <Form.Group className='actions text-center'>
          <div className='group'>
            <button
              className='button primary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                onSubmit(e)
              }}
              aria-label={t.SUBMIT_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_SEND}
            </button>
            <a
              href='/documents'
              className='button secondary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                DocumentStore.onCloseForm()
                navigate('/documents')
              }}
              style={{
                textDecoration: 'none',
                color: 'unset'
              }}
              aria-label={t.CANCEL_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_CANCEL}
            </a>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}

OtherContractPartner.propTypes = {
  file: PropTypes.object.isRequired,
  contractStore: PropTypes.object
}

export default inject('contractStore')(observer(OtherContractPartner))
